module.exports = __webpack_public_path__ + "img/edge_activites_saut_elastique.7a83384a.svg";